import { FileText, GitBranch, FileStack } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type TipoDocumento = { titulo: string; texto: string; icone: LucideIcon };

// Os três documentos que o sistema gera — copy alinhada ao vocabulário do
// domínio (packages/shared/src/dominio/vocabulario.ts, TIPOS_SOCIETARIOS).
export const TIPOS_DOCUMENTO: readonly TipoDocumento[] = [
  {
    icone: FileText,
    titulo: 'Contrato social',
    texto:
      'A constituição da sociedade — da SLU à LTDA — com toda cláusula obrigatória já fundamentada.',
  },
  {
    icone: GitBranch,
    titulo: 'Alteração contratual',
    texto:
      'Registra o evento que mudou — sede, sócio, capital — não reescreve o contrato inteiro.',
  },
  {
    icone: FileStack,
    titulo: 'Consolidação',
    texto:
      'O contrato vigente por inteiro, renderizado do estado atual. Nunca redigitado, nunca diverge do preâmbulo.',
  },
] as const;
